module.exports = __webpack_public_path__ + "static/media/markup.59bea2db.svg";